import React, { Component } from 'react';
import { Field } from 'redux-form';
import MenuItem from 'material-ui/MenuItem'
import { chunk } from 'lodash';
import Snackbar from 'material-ui/Snackbar';


import ColorPicker from '../../colorPicker/ColorPicker';
import { renderSelectField , /*renderSliderField, renderCheckbox, renderTextField*/ } from '../../../utils/materialUiReduxForms';
import { generateCssString } from '../../../actions/clientproduct/update';
import BetfairAppDesktopSample from './../../samples/betfairAppDesktop';
import {betfairAppStyleFields} from '../../../constants';
import { literals } from '../../../languages';
import { copyToClipBoard } from '../../../utils/helpers';




class BetfairAppForm extends Component {


  constructor (props) {
    super(props);
    this.state = {
      generatedCode: '',
      showCopyMsg: false,
      indexActiveColorPicker: -1
    }
  }

  componentDidUpdate (prevProps, prevState) {
    
    if (prevState.generatedCode !== this.state.generatedCode || this.state.generatedCode === '') {
      this.setState({
        'generatedCode': `<div class="tziroi-root" id="tziroi-root" data-clientId="${this.props.clientId}" data-productId="${this.props.productId}"></div><script type="text/javascript">document.write('<scr' + 'ipt type="text/javascript" async src="${process.env.REACT_APP_WIDGET_ASSETS_URL}/betfair-app/js/main.min.js"></scr' + 'ipt><link rel="stylesheet" type="text/css" href="${process.env.REACT_APP_WIDGET_ASSETS_CSS_URL}/${this.props.initialValues.id}.css?v=' + Date.now() + '"><link rel="stylesheet" type="text/css" href="${process.env.REACT_APP_WIDGET_ASSETS_URL}/betfair-app/css/main.min.css">');</script>`
      });
    }
  }

  activeColorPicker = (index) => {
    this.setState({indexActiveColorPicker: index})
  }

  renderColorFields() {
    const chunkOfStyleFields = chunk(betfairAppStyleFields(this.props.locale).colors, 2)

    const renderColorPicker = (fields = [], index) => {
      return fields.map((f, i) => {
        return (
          <div key={`${i}${f.value}`} className="form-input-style">
            <label>{f.title} </label>
            <div 
              className="colorpicker" 
              onClick={() =>this.activeColorPicker(`${index}${i}`)}
            >
              <ColorPicker
                isColorPickersVisible={this.props.isColorPickersVisible && this.state.indexActiveColorPicker === `${index}${i}`}
                indexActiveColorPicker={this.state.indexActiveColorPicker}
                name={`style#${f.value}`}
                defaultValue={f.defaultValue}
                isSquareVisible
                value={this.props.formValues[f.value]}
                onChange={color => this.props.change(f.value, color)}
              />
            </div>
          </div>
        )
      })
    }
  
    return chunkOfStyleFields.map((sf, i) =>  <div key={`${i}ccn`} className="form-row">{renderColorPicker(sf, i)}</div>)
  }


  resetStyleFields = () => {
    betfairAppStyleFields(this.props.locale).colors.forEach(c => {
      this.props.change(c.value, c.defaultValue);
    })

    this.props.change(betfairAppStyleFields(this.props.locale).font.value, betfairAppStyleFields(this.props.locale).font.defaultValue);
  }

  renderClientProductStyleFields = () => {
    return(
      <div>
        {this.renderColorFields()}
        <div className="form-input-style">
          <label>{literals.fontFamily[this.props.locale]}</label>
          <Field component={renderSelectField} name="style#font-family#@tziroi-table@" type="text"> 
            <MenuItem value={'Open Sans'} primaryText="Default" />
            <MenuItem value={'inherit'} primaryText="Inherit" />
            <MenuItem value={'Verdana'} primaryText="Verdana" />
            <MenuItem value={'Arial'} primaryText="Arial" />
            <MenuItem value={'Sans-Serif'} primaryText="Sans-Serif" />
            <MenuItem value={'Times New Roman'} primaryText="Times New Roman" />
            <MenuItem value={'Tahoma'} primaryText="Tahoma" />
          </Field>
        </div>
        <div className="form-input-style">
          <label>{literals.sizeScale[this.props.locale]}</label>
          <Field component={renderSelectField} name="style#transform#@tziroi-table@" type="text"> 
            <MenuItem value={'scale(1)'} primaryText="100%" />
            <MenuItem value={'scale(.9)'} primaryText="90%" />
            <MenuItem value={'scale(.8)'} primaryText="80%" />
            <MenuItem value={'scale(.7)'} primaryText="70%" />
          </Field>
        </div>
        {/* <div className="form-input-style">
          <Field 
            type="text"
            component={renderSliderField} 
            name="style#transform#@tziroi-table@" style={{width:'300px'}}
            max={1}
            min={0}
            defaultValue={1}
            step={.05}
            />
        </div> */}
      </div>
    );
  }

  renderPreview () {
    return (
      <div className="product-preview-container">
        <style>
          {generateCssString(this.props.formValues)}
        </style>
        <BetfairAppDesktopSample locale={this.props.locale} />
      </div>
    );
  }

  handleCopyCode = () => {
    copyToClipBoard(this.state.generatedCode);
    this.setState({
      'showCopyMsg': true
    });
  }
  
  render () {
    return(
      <div>
        <div className="form-divider">{literals.style[this.props.locale]}</div>
        {this.renderClientProductStyleFields()}
        <div className="btn btn-secondary" onClick={this.resetStyleFields}>{literals.resetToDefaults[this.props.locale]}</div>
        <div className="form-divider">{literals.previewLayout[this.props.locale]}</div>
        {this.renderPreview()}
        <div className="form-code">
          <div className="form-code__header">
            {literals.generateCodeMessage[this.props.locale]}
          </div>
          <div onClick={this.handleCopyCode} className="copy-btn">
            <span>{literals.copy[this.props.locale]}</span>
            <i className="fa fa-clipboard" aria-hidden="true"></i>
          </div>
          <Snackbar
            open={Boolean(this.state.showCopyMsg)}
            message={this.props.locale ? <div style={{textAlign:'center'}}> {literals.copySuccessMessage[this.props.locale]} <i style={{marginLeft:'15px'}}className="fa fa-check"></i></div>  : ''}
            autoHideDuration={4000}
            onRequestClose = {()=> {this.setState({'showCopyMsg': false})}}
          />
          <pre> {this.state.generatedCode} </pre>
        </div>
      </div>
    )
  }

}


export default BetfairAppForm;


// WEBPACK FOOTER //
// ./src/components/clientproduct/productForms/betfairApp.js